import React from 'react';
import { ArrowRight } from 'lucide-react';
import { formatRelativeTime } from '../../utils/dateUtils';
import { GTMProjectTransition, STAGE_LABELS } from '../../types/pipeline';

interface TransitionListProps {
  transitions: GTMProjectTransition[];
}

export const TransitionList: React.FC<TransitionListProps> = ({ transitions }) => {
  if (transitions.length === 0) {
    return <p className="text-xs text-neutral-400">No transitions yet.</p>;
  }

  return (
    <ul className="space-y-1.5">
      {transitions.map(t => (
        <li key={t.id} className="text-xs text-neutral-600 flex items-center gap-1.5 flex-wrap">
          <span className="text-neutral-400">{t.from_stage ? STAGE_LABELS[t.from_stage] : '—'}</span>
          <ArrowRight className="w-3 h-3 text-neutral-300" />
          <span className="font-medium text-neutral-700">{STAGE_LABELS[t.to_stage]}</span>
          <span className="text-neutral-400">· {t.actor}</span>
          {t.reason && <span className="text-neutral-400">· {t.reason}</span>}
          <span className="text-2xs text-neutral-300 ml-auto">{formatRelativeTime(t.created_at)}</span>
        </li>
      ))}
    </ul>
  );
};
